import React from 'react';
import { FileText, Download, Trash2 } from 'lucide-react';
import { Button } from '../../../../../../components/common/Button';
import { useSurvey } from '../../../../../../contexts/SurveyContext';

const FilesTab = () => {
  const { activeSurvey } = useSurvey();

  if (!activeSurvey) {
    return (
      <div className="p-4 text-center text-gray-400">
        No active survey selected
      </div>
    );
  }

  return (
    <div className="p-4 space-y-4">
      <h2 className="text-lg font-medium text-white">Survey Files</h2>
      
      <Button
        onClick={() => document.getElementById('file-upload').click()}
        className="w-full bg-blue-600 hover:bg-blue-700 text-white"
      >
        Upload Files
      </Button>
      <input
        id="file-upload"
        type="file"
        multiple
        className="hidden"
        onChange={(e) => {
          // Handle file upload
        }}
      />

      <div className="space-y-2">
        {activeSurvey.files?.map((file) => (
          <div 
            key={file.id}
            className="flex items-center justify-between p-3 bg-gray-700/50 rounded-lg"
          >
            <div className="flex items-center gap-3">
              <FileText className="w-5 h-5 text-blue-400" />
              <div>
                <div className="text-white">{file.name}</div>
                <div className="text-sm text-gray-400">
                  Added {new Date(file.createdAt).toLocaleDateString()}
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Button
                onClick={() => {/* Handle download */}}
                className="p-2 hover:bg-gray-600 rounded-lg text-gray-400 hover:text-white"
              >
                <Download className="w-4 h-4" />
              </Button>
              <Button
                onClick={() => {/* Handle delete */}}
                className="p-2 hover:bg-red-500/20 rounded-lg text-red-400 hover:text-red-300"
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          </div>
        ))}

        {(!activeSurvey.files || activeSurvey.files.length === 0) && (
          <div className="text-center text-gray-400 py-4">
            No files uploaded yet
          </div>
        )}
      </div>
    </div>
  );
};

export default FilesTab;